'use strict'

class RundownItemBase {

    constructor (
        Contact,
        $http,
        $scope,
        $state,
        $timeout,
    ) {
        this.Contact = Contact
        this.$http = $http
        this.$scope = $scope
        this.$state = $state
        this.$timeout = $timeout

        this.loaded = false
        this.detailsLoaded = false

        this.contactSearchData = ['']

        //item data
        this.customFieldsRaw = []
        this.customFields = {}
        this.formdata = {}

        $scope.$on('$destroy', this.destroy.bind(this))
    }

    getModelTypes () {
        return this.$http.get('/modeltypes/item', { cache: true }).then(response => {
            this.customFieldsRaw = response.data.item
            response.data.item.forEach((data) => {
                this.customFields[data.id] = data.fields
            })
            return response.data
        })
    }

    fetch () {
        this.getModelTypes().then(() => {
            this.$timeout(() => {
                this.initView()
            })
        })
    }

    initView () {
    }

    contactSearch (query) {
        if (!query) {
            return [{ add: true }]
        } else {
            return this.$http.get('/contacts/search/' + encodeURIComponent(query)).then(result => {
                let data = result.data
                data.push({ add: true })

                return data
            })
        }
    }

    onContactSelect () {
        this.$scope.searchText = ''
        this.contactAddToItem(this.selectedContact)
        this.contactBlur()
    }

    contactBlur () {
        let input = angular.element(document.querySelector('md-autocomplete input'))
        input.blur()
    }

    contactAddToItem (contact) {
        if (contact) {

            if (contact.add) {
                this.contactCreate()
                return
            }

            const { formdata, $timeout } = this

            if (!formdata.contacts) {
                formdata.contacts = []
            }

            // Clear contact search suggest
            $timeout(() => {
                this.clearContactSearch()
            }, 250)

            //Check if contact is already in the list
            const index = formdata.contacts.findIndex(obj => contact.id === obj.id)
            if (index !== -1) {
                formdata.contacts[index] = contact
            } else {
                formdata.contacts.push(contact)
            }
        }
    }

    contactOpenBlade (id) {
        let contactState = this.$state.current.name
        if (this.$state.current.name.split('.').indexOf('contact') > -1) {
            this.$state.go('^')

            setTimeout(() => {
                this.$state.go(contactState, {
                    contactId: id,
                })
            }, 400)//we have to wait 400ms for the delete animation of onExit that we cant cancel
        } else {
            this.$state.go('.contact', {
                contactId: id
            })
        }
    }

    clearContactSearch () {
        const { $scope } = this
        $scope.selectedOption = undefined
        $scope.searchText = ''
        $scope.$$childTail.searchText = ''
    }

    contactCreate () {
        this.Contact.save({}, (data) => {

            this.$state.go('.contact', {
                contactId: data.id,
                create: true,
                name: this.$scope.searchText
            })

            this.clearContactSearch()
        })
    }

    destroy () {
    }

    contactUpdate (event, data) {
        console.log(data)

        if (data.hasOwnProperty('id')) {
            if (!this.formdata.contacts) {
                this.formdata.contacts = []
            }

            const existing_item = this.formdata.contacts.find(contact => data.id === contact.id)

            if (existing_item) {
                angular.extend(existing_item, data)
            } else {
                this.formdata.contacts.push(data)
            }
        }

    }

    contactDelete (event, id) {
        event.preventDefault()
        const { formdata } = this

        //Check if contact is already in the list
        const index = formdata.contacts.findIndex(contact => (
            ('' + id) === ('' + contact.id)
        ))

        if (index !== -1) {
            formdata.contacts.splice(index, 1)
        }
    }

    tagAdd (value) {
        //placeholder
    }

    tagRemove (index) {
        //placeholder
    }

    blockLocalChips ($chip) {
        //placeholder
    }

    tagSearch (query) {
        return this.$http.get('/tags/search/' + encodeURIComponent(query)).then(result => {
            return result.data
        })
    }

    save () {
        //placeholder for campaign
    }

    backToCampaign () {
        //placeholder for campaign
    }
}

RundownItemBase.$inject = [
    'Contact',
    '$http',
    '$scope',
    '$state',
    '$timeout'
]

module.exports = RundownItemBase
